import { render, staticRenderFns } from "./NewUserEditor.vue?vue&type=template&id=23bdc87a&scoped=true&"
import script from "./NewUserEditor.vue?vue&type=script&lang=js&"
export * from "./NewUserEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bdc87a",
  null
  
)

export default component.exports